module.exports = __webpack_public_path__ + "img/search.8fa24f75.svg";